var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "#C2C1C1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99992 5.66634L0.333252 0.333008L9.66659 0.333008L4.99992 5.66634Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrow);
export default __webpack_public_path__ + "static/media/sort_arrow.cf8199e426fb3a3d25f9ddff02882222.svg";
export { ForwardRef as ReactComponent };